import { Breadcrumb, Flex, Space } from "antd";
import { MainLayout } from "components/layouts";
import CompanyMenu from "./CompanyMenu";
import styles from "../styles/CompanyProfile.module.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const CompanyProfile = ({
  pageType = "view",
  getPage = () => { },
  handleMenuChange = () => { },
  setMenu = () => { },
  setPageType = () => { },
}) => {
  const { t } = useTranslation();
  const [currentTab, setCurrentTab] = useState("");

  const PAGE_TYPE = {
    view: "view",
    edit: "edit",
    main: "main",
    create: "create"
  };

  const menuBreadcrumbMapping = {
    profile: t("company_profile.header"),
    organization: t("organization.header"),
    position: t("position.header"),
    condition: t("condition.header"),
    branch_list: t("branch.header"),
    document: t("document.header"),
    appearance: t("appearance.header"),
  }

  const getBreadcrumbItems = () => {
    const items = [
      { title: t("home.header"), href: "/" },
      { title: t("configuration.header"), href: "" },
      { title: t("company_setting.header"), href: "" },
    ];

    if (currentTab && menuBreadcrumbMapping[currentTab]) {
      const isNotView = pageType !== PAGE_TYPE.view;

      items.push({
        title: menuBreadcrumbMapping[currentTab],
        href: isNotView ? "#" : undefined,
        onClick: isNotView
          ? (e) => {
            e.preventDefault();
            if (currentTab === "branch_list") {
              setPageType(PAGE_TYPE.main);
            } else {
              setPageType(PAGE_TYPE.view);
            }
          }
          : undefined,
      });
    }

    if (pageType === PAGE_TYPE.edit) {
      items.push({ title: t("common.edit") });
    } else if (pageType === PAGE_TYPE.create) {
      items.push({ title: t("common.create") });
    } else if (pageType === PAGE_TYPE.view && currentTab === "branch_list") {
      items.push({ title: t("common.view") });
    }

    return items;
  };

  const onMenuChange = (key) => {
    if (key.includes('.')) {
      const mainTab = key.split('.')[0];
      setCurrentTab(mainTab);
    } else {
      setCurrentTab(key);
    }

    handleMenuChange(key);
  };

  const handleInitialMenuSet = (initialMenuKey) => {
    if (initialMenuKey) {
      if (initialMenuKey.includes('.')) {
        const mainTab = initialMenuKey.split('.')[0];
        setCurrentTab(mainTab);
      } else {
        setCurrentTab(initialMenuKey);
      }
    }
  };

  const wrappedSetMenu = (menuKey) => {
    handleInitialMenuSet(menuKey);
    setMenu(menuKey);
  };

  return (
    <MainLayout>
      <Flex vertical style={{ rowGap: 40 }}>
        <Flex vertical>
          <Breadcrumb items={getBreadcrumbItems()} />
          <h2>{menuBreadcrumbMapping[currentTab] || t("company_setting.header")}</h2>
        </Flex>
        <Space className={styles.menuContainer} size={24} direction="vertical">
          <CompanyMenu setMenu={wrappedSetMenu} pageType={pageType} onChange={onMenuChange}>
            {getPage()}
          </CompanyMenu >
        </Space>
      </Flex>
    </MainLayout>
  );
};

export default CompanyProfile;
